import { Component } from '@angular/core';
import { App, IonicPage, MenuController, NavController, NavParams } from 'ionic-angular';
import { LoginControl } from '../../providers/helpers/login';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';
import { HomePage } from '../home/home';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  form: any = {
    login: "",
    senha: ""
  }

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private service: ServiceProvider, private msgHelper: MessageHelper,
    private loginCtrl: LoginControl, private menuCtrl: MenuController,
    private app: App) {
  }

  ionViewWillEnter(){

  }

  makeLogin() {

    if (this.form.login == "") {
      return this.msgHelper.showToast(
        'Digite o seu login ou e-mail', 'bottom', 1500);
    }

    if (this.form.senha == ""){
      return this.msgHelper.showToast(
        "Digite a senha",
        "bottom",
        1500
      );
    }

    this.msgHelper.createLoading('crescent','Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.form,"/usuarios/auth").then((result: any) => {
      this.msgHelper.closeLoading();
      let resultData : any = result;
      if (resultData.result == 0){
        return this.msgHelper.showAlert("Opps!",result.message);
      }

      this.loginCtrl.setUser(resultData.data);

      let date = new Date();
      this.loginCtrl.deleteDate();
      this.loginCtrl.setDate(date.toString());

      this.menuCtrl.enable(true,"menu-principal");

      this.app.getRootNavs()[0].setRoot(HomePage);
      this.app.getRootNavs()[0].popToRoot();
      
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Oops!", error.message);
    });

  }

}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts